/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_Profile_Header_Back_To_ChatInputs */

const es_user_profile_header_back_to_chat = /** @type {(inputs: User_Profile_Header_Back_To_ChatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volver al chat`)
};

const en_user_profile_header_back_to_chat = /** @type {(inputs: User_Profile_Header_Back_To_ChatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Back to chat`)
};

/**
* | output |
* | --- |
* | "Back to chat" |
*
* @param {User_Profile_Header_Back_To_ChatInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const user_profile_header_back_to_chat = /** @type {((inputs?: User_Profile_Header_Back_To_ChatInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_Profile_Header_Back_To_ChatInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_user_profile_header_back_to_chat(inputs)
	return en_user_profile_header_back_to_chat(inputs)
});
export { user_profile_header_back_to_chat as "user.profile.header.back_to_chat" }